import { memo } from "react";

import { IUser } from "@/api";

import { IEventLogComponent } from "../events";

export const Author = memo(
  ({
    authorId,
    usersById,
  }: {
    authorId: IUser["id"];
    usersById: IEventLogComponent["usersById"];
  }) => {
    const author = usersById?.[authorId] || { firstName: "An M7 Admin", lastName: "" };

    return (
      <b data-testid="author">
        {author.firstName} {author.lastName}
      </b>
    );
  },
);
